import { FunctionComponent } from "enzyme";
import { IconProps } from "./constants";

const IconArrow: FunctionComponent<IconProps> = ({
  width = "22",
  height = "19",
  className = "",
  name = "inprogress",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-name={name}
    >
      <path
        d="M12.5 17L20 9.5M20 9.5L12.5 2M20 9.5L2 9.50026"
        stroke="#305953"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 17L20 9.5M20 9.5L12.5 2M20 9.5L2 9.50026"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconArrow;
